import styled from 'styled-components';

export const MenuWrapper = styled.div`
  line-height: 70px;
  margin: 0 30px;
  text-transform: uppercase;
  display: flex;
  white-space: nowrap;

  a {
    text-decoration: none;
  }
`;

export const MenuItem = styled.div`
  position: relative;
  margin: 0 20px;

  :hover {
    .MenuParent {
      color: #dfdfdf;
    }

    .MenuChildren {
      display: block;
    }
  }
  .MenuParent {
    color: #CCD6DF;
    cursor: pointer;

    span {
      margin-left: 10px;
    }

    a {
      color: #CCD6DF;
    }
  }

  .MenuChildren {
    display: none;
    background-color: #dfdfdf;
    line-height: 30px;
    left: -20px;
    padding: 8px 0;
    position: absolute;
    top: 60px;
    z-index: 10;

    &:after {
      bottom: 100%;
      left: 21px;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-bottom-color: #dfdfdf;
      border-width: 6px;
      margin-right: -1 * 6px;
    }
  }

  .MenuChild {
    padding: 0 16px;
  }
`;
